import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { NOTIFICHE_PATH } from '@/lib/notifiche/consenso';

/**
 * La riga «Notifiche ›» accanto al gruppo Privacy del tab Amici (L-2500): porta alla pagina
 * `FriendsNotifiche`. Fatta come `RigaAccountBloccati`, MA senza numero e senza query: la riga non
 * chiama niente, quindi la GET di consenso parte solo quando la pagina e' aperta.
 * Il chiamante la monta solo con `env.featureNotificationSettingsEnabled`.
 */
export function RigaNotifiche() {
  const { t } = useTranslation('general');
  return (
    <Link
      to={NOTIFICHE_PATH}
      data-testid="notifiche-link"
      className="flex min-h-[56px] items-center gap-3 border-t border-border px-4 py-2 text-sm font-semibold text-fg"
    >
      <span className="min-w-0 flex-1">{t('notifiche.title', { defaultValue: 'Notifications' })}</span>
      <ChevronRight aria-hidden className="h-4 w-4 shrink-0 text-fg-muted" />
    </Link>
  );
}
